import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import sheet from "@/components/sheet/sheet.vue";
import util from '@/libs/util';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { tabulation } from "@/mixins/index";
export default {
  components: {
    sheet: sheet
  },
  mixins: [tabulation],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      action: process.env.VUE_APP_API + '/sz-gm/szUserInfoExport',
      headers: {
        'Authorization': '',
        'Request-Url': ''
      },
      fileList: [{}],
      fileLoading: false,
      dialogShow: false,
      uploadData: {
        type: '',
        env_id: '',
        game_id: ''
      },
      typeList: [{
        label: this.$t('userId'),
        value: 'user_id'
      }, {
        label: this.$t('roleId'),
        value: 'role_id'
      }]
    };
  },
  created: function created() {
    this.headers['Authorization'] = 'Bearer ' + (util.cookies.get('token') || '');
  },
  methods: {
    open: function open() {
      this.dialogShow = true;
      this.uploadData = _objectSpread(_objectSpread({}, this.uploadData), this.prod);
    },
    fileChang: function fileChang(type) {
      var flieData = document.getElementById("file" + type).files;

      if (flieData[0].type !== 'text/csv') {
        this.$message.error(this.$t('fileTypeError'));
        document.getElementById("file" + type).value = '';
        return;
      }

      this.$set(this.fileList, type, flieData[0]);
      document.getElementById("file" + type).value = '';
    },
    removeFile: function removeFile(index) {
      this.$set(this.fileList, index, {});
    },
    clearData: function clearData() {
      this.fileList = [{}];
      this.uploadData = {
        type: '',
        env_id: '',
        game_id: ''
      };
    },
    uploadFile: function uploadFile() {
      var _this = this;

      var fileList = this.fileList;

      if (!fileList[0].name) {
        this.$message.warning(this.$t('pleaseSelectFile'));
        return;
      }

      if (!this.uploadData.type) {
        this.$message.warning(this.$t('pleaseSelectType'));
        return;
      }

      this.fileLoading = true;
      var formDate = new FormData();
      fileList[0].name && formDate.append("file", fileList[0]);

      for (var key in this.uploadData) {
        formDate.append(key, this.uploadData[key]);
      }

      this.headers['Request-Url'] = this.$route.path;
      axios.post(this.action, formDate, {
        headers: this.headers
      }).then(function (res) {
        if (res.data.status == 200) {
          var exportList = res.data.data || [];

          if (exportList.length === 0) {
            _this.$message.warning(_this.$t('noDataToExport'));

            return;
          }

          exportList.map(function (i) {
            i.recharge_amount = _this.$utils.conversion(i.recharge_amount).toFixed(2);
            i.real_time_amount = _this.$utils.conversion(i.real_time_amount).toFixed(2);
            i.server_name = _this.serverList.findIndex(function (j) {
              return j.serverID == i.server_id;
            }) > -1 ? _this.serverList.find(function (j) {
              return j.serverID == i.server_id;
            }).serverName : i.server_id;
          });

          _this.exportTableData(exportList);

          _this.dialogShow = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }).finally(function () {
        _this.fileLoading = false;
      });
    },
    exportTableData: function exportTableData(rawData) {
      var columnConfig = [{
        prop: 'server_id',
        label: this.$t('serverId')
      }, {
        prop: 'role_name',
        label: this.$t('roleName')
      }, {
        prop: 'role_id',
        label: this.$t('roleId')
      }, {
        prop: 'account',
        label: this.$t('account')
      }, {
        prop: 'gate_user_id',
        label: this.$t('gatewayUserId')
      }, {
        prop: 'phone',
        label: this.$t('phoneNumber')
      }, {
        prop: 'level',
        label: this.$t('prestigeLevel')
      }, {
        prop: 'fighting',
        label: this.$t('totalPower')
      }, {
        prop: 'recharge_amount',
        label: this.$t('totalRechargeAmount')
      }, {
        prop: 'real_time_amount',
        label: this.$t('realTimeRechargeAmount')
      }, {
        prop: 'third_login_type',
        label: this.$t('thirdPartyLoginType')
      }, {
        prop: 'device_id',
        label: this.$t('recentLoginDeviceId')
      }, {
        prop: 'ext',
        label: this.$t('extendedParams')
      }, {
        prop: 'register_time',
        label: this.$t('registerTime')
      }, {
        prop: 'last_login_time',
        label: this.$t('recentLoginTime')
      }];
      var formattedData = rawData.map(function (item) {
        var row = {};
        columnConfig.forEach(function (col) {
          row[col.label] = item[col.prop] !== undefined && item[col.prop] !== null ? item[col.prop] : '';
        });
        return row;
      });
      var worksheet = XLSX.utils.json_to_sheet(formattedData);
      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.$t('userDetails'));
      XLSX.writeFile(workbook, "".concat(this.$t('yujianPlayerDetailsExport'), ".xlsx"));
    }
  }
};